import { getRouteApi } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Tabs, type TabDefinition } from '@vestigas/ui/molecules';

import { ImprintContent } from './components/ImprintContent';
import { PrivacyContent } from './components/PrivacyContent';
import { TermsContent } from './components/TermsContent';
import { type LegalTab } from './constants';

const LegalRoute = getRouteApi('/(main)/legal/');

export function LegalPage() {
  const { t } = useTranslation('legal');
  const { tab: activeTab } = LegalRoute.useSearch();
  const navigate = LegalRoute.useNavigate();

  const tabs: TabDefinition[] = [
    {
      content: () => <ImprintContent />,
      label: t(($) => $.tabs.imprint),
      value: 'imprint',
      views: [],
    },
    {
      content: () => <PrivacyContent />,
      label: t(($) => $.tabs.privacy),
      value: 'privacy',
      views: [],
    },
    {
      content: () => <TermsContent />,
      label: t(($) => $.tabs.terms),
      value: 'terms',
      views: [],
    },
  ];

  return (
    <div className="flex w-full flex-col gap-6 p-4 md:p-6">
      <Tabs
        tabs={tabs}
        value={activeTab}
        onChange={(_event, value) =>
          void navigate({ replace: true, search: { tab: value as LegalTab } })
        }
      />
    </div>
  );
}
